import { render } from "./AppCenter.vue?vue&type=template&id=34046ff8&scoped=true"
import script from "./AppCenter.vue?vue&type=script&lang=js"
export * from "./AppCenter.vue?vue&type=script&lang=js"

import "./AppCenter.vue?vue&type=style&index=0&id=34046ff8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-34046ff8"

export default script